import { addCommasToNumber } from "../lib/general/formatting";
import logo from "../assets/aws_f1_logo.png";
import './../App.css';
import { useEffect, useState } from "react";
import { playButtonSound } from "../lib/sounds";

export function ResultModal({
  lapTimeReduction,
  remainingResources,
  f1GarageScore,
  onDismiss,
  onSubmit,
  showTryAgain,
}: {
  lapTimeReduction: number,
  remainingResources: number,
  f1GarageScore: number,
  onDismiss: () => void,
  onSubmit: () => void,
  showTryAgain: boolean,
}) {
  // using css inside of this component, create a modal which darkens the screen and has a container which shows their users score and their money balance, add two buttons in the bottom (left and right) where there user can choose to dismiss or submit

  return (
    <div className="modal-wrapper">
      <div className="modal-container">
        <h1>Your Result</h1>
        <div className="modal-content">
          <div className="modal-content-left">
            <h3>Lap Time Reduction</h3>
            <h3>Remaining Resources</h3>
            <h3>AWS Drive your Data score</h3>
          </div>
          <div className="modal-content-right">
            <h3>-{lapTimeReduction.toFixed(2)}s</h3>
            <h3>${addCommasToNumber(remainingResources)}</h3>
            <h3>{f1GarageScore}</h3>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" onClick={() => {
            playButtonSound();
            onSubmit();
          }}>Submit</button>
        </div>
      </div>
    </div>
  )
}

export function InfoModal({
  title,
  description,
  onDismiss,
} : {
  title: string,
  description: string,
  onDismiss: () => void,
}) {
  return (
    <div className="modal-wrapper">
      <div className="info-modal-container">
        <div className="info-modal-header">
          <h2>{title}</h2>
          <button type="button" className="outline-button" onClick={() => {
            playButtonSound();
            onDismiss();
          }}>Dismiss</button>
        </div>
        <div className="info-modal-content">
          <p>{description}</p>
        </div>
      </div>
    </div>
  )
}

export function TimesUpModal({
  onSubmit,
}: {
  onSubmit: () => void,
}) {
  return (
    <div className="modal-wrapper">
      <div className="times-up-modal-container">
        <h1>Time's Up!</h1>
        <div className="times-up-modal-content">
          <p>Click the button below to see your results.</p>
        </div>
        <div className="times-up-modal-footer">
          <button type="button" onClick={() => {
            playButtonSound();
            onSubmit();
          }}>Submit</button>
        </div>
      </div>
    </div>
  )
}

export interface RunningSimulationModalProps {
  readyToSubmitChecker: (progress: number) => void;
}

export function RunningSimulationModal({
  readyToSubmitChecker,
}: RunningSimulationModalProps) {

  const [progress, setProgress] = useState(0);

  // Loading bar which takes between 1-3 seconds to complete and has random progress

  useEffect(() => {
    const interval = setInterval(() => {

      if (progress < 100) {

        const newVal = progress + Math.floor(Math.random() * 1.5);

        if (newVal > 100) {
          setProgress(100);
        } else {
          setProgress(newVal);
        }
      } else {
        readyToSubmitChecker(progress);
        clearInterval(interval);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [progress]);


  return (
    <div className="modal-wrapper">
      <div className="running-simulation-modal-container">
        <h2 style={{
          // no wrap
          whiteSpace: "nowrap",
        }}>Running Simulation</h2>
        <div className="running-simulation-modal-content">
          <p>Simulating your car's performance...</p>
          <div className="progress-container">
            <div className="progress">
              <div className="fill a" style={{
                width: `${progress}%`,
                transition: "width 0.1s",
              }}>
              </div>
            </div>
            <div className="progress-label-container">
              <span>{progress}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}